const messages = {
    es: {
        facturacion: {
            title: 'Facturación',
            menuTitle: 'Facturación',
            subtitle: 'Gestión de facturas electrónicas AFIP',
            config: {
                title: 'Configuración AFIP',
                subtitle: 'Certificados y datos de facturación electrónica'
            },
            labels: {
                tipoComprobante: 'Tipo',
                numeroComprobante: 'Número',
                cae: 'CAE',
                vencimientoCae: 'Vencimiento CAE',
                estado: 'Estado',
                cliente: 'Cliente',
                total: 'Total',
                fechaEmision: 'Fecha',
                subtotal: 'Subtotal',
                iva: 'IVA',
                medioPago: 'Medio de Pago',
                puntoVenta: 'Punto de Venta',
                items: 'Items',
                ultimoError: 'Último Error',
                intentos: 'Intentos'
            },
            estados: {
                EMITIDA: 'Emitida',
                PENDIENTE: 'Pendiente',
                ERROR: 'Error',
                PROCESANDO: 'Procesando',
                CANCELADA: 'Cancelada'
            },
            tipos: {
                FACTURA_A: 'Factura A',
                FACTURA_B: 'Factura B',
                FACTURA_C: 'Factura C',
                NOTA_DEBITO_A: 'Nota de Débito A',
                NOTA_DEBITO_C: 'Nota de Débito C',
                NOTA_CREDITO_A: 'Nota de Crédito A',
                NOTA_CREDITO_C: 'Nota de Crédito C'
            },
            actions: {
                emitir: 'Emitir Factura',
                descargarPDF: 'Descargar PDF',
                enviarEmail: 'Enviar por Email',
                reintentar: 'Reintentar',
                procesarPendientes: 'Procesar Pendientes',
                marcarPendiente: 'Marcar como Pendiente',
                verDetalle: 'Ver Detalle',
                configurar: 'Configurar AFIP'
            },
            messages: {
                emitida: 'Factura emitida correctamente',
                error: 'Error al emitir factura',
                pdfGenerado: 'PDF generado correctamente',
                emailEnviado: 'Factura enviada por email',
                pendienteMarcada: 'Factura marcada como pendiente',
                reintentando: 'Reintentando emisión...',
                noConfiguracion: 'No hay configuración AFIP activa. Configure en Admin Panel > Empresas',
                procesandoPendientes: 'Procesando facturas pendientes...',
                todasProcesadas: 'Todas las facturas pendientes fueron procesadas'
            },
            warnings: {
                sinCliente: 'Se emitirá factura a consumidor final genérico',
                produccion: '⚠️ Modo PRODUCCIÓN: Las facturas serán reales y reportadas a AFIP',
                errorDefinitivo: 'Este error no puede ser corregido automáticamente',
                certificadoVencido: 'El certificado AFIP ha vencido. Renuévelo en la configuración.'
            },
            help: {
                cuit: '11 dígitos sin guiones',
                puntoVenta: 'Número de punto de venta autorizado por AFIP',
                certificado: 'Certificado digital obtenido de AFIP',
                clavePrivada: 'Clave privada generada al crear el CSR',
                obtenerCertificados: '¿Cómo obtener los certificados AFIP?',
                pasosCertificados: {
                    paso1: 'Generar clave privada y CSR con OpenSSL',
                    paso2: 'Ir a AFIP: Homologación o Producción',
                    paso3: 'Subir el CSR y descargar el certificado',
                    paso4: 'Cargar ambos archivos aquí'
                }
            }
        }
    },
    en: {
        facturacion: {
            title: 'Billing',
            menuTitle: 'Billing',
            subtitle: 'AFIP electronic invoice management',
            config: {
                title: 'AFIP Configuration',
                subtitle: 'Certificates and electronic billing data'
            },
            labels: {
                tipoComprobante: 'Type',
                numeroComprobante: 'Number',
                cae: 'CAE',
                vencimientoCae: 'CAE Expiration',
                estado: 'Status',
                cliente: 'Customer',
                total: 'Total',
                fechaEmision: 'Date',
                subtotal: 'Subtotal',
                iva: 'VAT',
                medioPago: 'Payment Method',
                puntoVenta: 'Point of Sale',
                items: 'Items',
                ultimoError: 'Last Error',
                intentos: 'Attempts'
            },
            estados: {
                EMITIDA: 'Issued',
                PENDIENTE: 'Pending',
                ERROR: 'Error',
                PROCESANDO: 'Processing',
                CANCELADA: 'Cancelled'
            },
            tipos: {
                FACTURA_A: 'Invoice A',
                FACTURA_B: 'Invoice B',
                FACTURA_C: 'Invoice C',
                NOTA_DEBITO_A: 'Debit Note A',
                NOTA_DEBITO_C: 'Debit Note C',
                NOTA_CREDITO_A: 'Credit Note A',
                NOTA_CREDITO_C: 'Credit Note C'
            },
            actions: {
                emitir: 'Issue Invoice',
                descargarPDF: 'Download PDF',
                enviarEmail: 'Send via Email',
                reintentar: 'Retry',
                procesarPendientes: 'Process Pending',
                marcarPendiente: 'Mark as Pending',
                verDetalle: 'View Details',
                configurar: 'Configure AFIP'
            },
            messages: {
                emitida: 'Invoice issued successfully',
                error: 'Error issuing invoice',
                pdfGenerado: 'PDF generated successfully',
                emailEnviado: 'Invoice sent via email',
                pendienteMarcada: 'Invoice marked as pending',
                reintentando: 'Retrying issuance...',
                noConfiguracion: 'No active AFIP configuration. Configure in Admin Panel > Companies',
                procesandoPendientes: 'Processing pending invoices...',
                todasProcesadas: 'All pending invoices have been processed'
            },
            warnings: {
                sinCliente: 'Invoice will be issued to generic final consumer',
                produccion: '⚠️ PRODUCTION Mode: Invoices will be real and reported to AFIP',
                errorDefinitivo: 'This error cannot be corrected automatically',
                certificadoVencido: 'AFIP certificate has expired. Renew it in configuration.'
            },
            help: {
                cuit: '11 digits without hyphens',
                puntoVenta: 'Point of sale number authorized by AFIP',
                certificado: 'Digital certificate obtained from AFIP',
                clavePrivada: 'Private key generated when creating the CSR',
                obtenerCertificados: 'How to obtain AFIP certificates?',
                pasosCertificados: {
                    paso1: 'Generate private key and CSR with OpenSSL',
                    paso2: 'Go to AFIP: Testing or Production',
                    paso3: 'Upload CSR and download certificate',
                    paso4: 'Upload both files here'
                }
            }
        }
    }
}

export default messages
